import { render, staticRenderFns } from "./InstrumentDetail.vue?vue&type=template&id=8e97d864&scoped=true"
import script from "./InstrumentDetail.vue?vue&type=script&lang=ts"
export * from "./InstrumentDetail.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentDetail.vue?vue&type=style&index=0&id=8e97d864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e97d864",
  null
  
)

export default component.exports